import { CIcon } from '~/icons/types'
export const ciParking: CIcon = {
  name: 'parking',
  type: 'solid',
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12.9 8.5h-2.5V12h2.5c.9 0 1.7-.8 1.7-1.8s-.7-1.7-1.7-1.7Z'
    },
    {
      d:
        'M19 2H5C3.3 2 2 3.3 2 5v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3Zm-6.1 13.5h-2.5v2.6c0 .4-.3.9-.8.9H7.8c-.4 0-.8-.3-.8-.9V5.9c0-.5.4-.9.8-.9h5.1c2.8 0 5.1 2.4 5.1 5.2 0 2.8-2.3 5.3-5.1 5.3Z'
    },
    {
      d:
        'M12.9 5H7.8c-.4 0-.8.4-.8.9v12.2c0 .6.4.9.8.9h1.7c.5 0 .8-.4.8-.9v-2.6h2.5c2.8 0 5.1-2.4 5.1-5.2 0-2.8-2.2-5.3-5-5.3Zm0 7h-2.5V8.5h2.5c.9 0 1.7.8 1.7 1.8s-.7 1.7-1.7 1.7Z',
      fill: '#fff'
    }
  ]
}
